import { Message } from 'element-ui';
import BaseRequest from './BaseRequest';
import Apis from './Apis';
import DataCenterLog from './DataCenterLog';
import ApiDomain from './ApiDomain';
import * as $cache from '@/common/cache';
import { logoutBySSO } from '@/common/auth';

class QuRequest extends BaseRequest {
  constructor() {
    super();
    this.Apis = Apis;
    this.apiDomain = new ApiDomain();
  }

  getUrl(api) {
    return this.apiDomain.getUrl(api);
  }

  nativeSend(api, data = {}) {
    // eslint-disable-next-line no-param-reassign
    data = {
      dtu: 200,
      ...data,
    };

    if (api.project === 'perm') {
      data.project = 'perm';
    }

    return super
      .send(
        {
          url: api.url,
          type: api.type,
          timeout: api.timeout,
          headers: api.headers,
        },
        data,
      )
      .then(
        (response) => this.responseInterceptor(response, api),
        (error) => this.errorInterceptor(error),
      );
  }

  send(api, data = {}) {
    let url = this.apiDomain.getUrl(api);
    let token = ($cache.localGet($cache.AUTH) || {}).token || '';
    if(location.host.startsWith('localhost')){
        token = "7490fB15GYWimBC4fZVSvBpUCRb8C9zH6lmm6IdJDRwCYr2xy82xxROvogHsB3EIQ1nNEg"
    }
    return this.nativeSend(
      {
        url: url,
        type: api.type,
        timeout: api.timeout,
        headers: {
          ...api.headers,
          token: token,
        },
        author: api._author || '',
        project: api.project,
      },
      data,
    );
  }
  responseInterceptor(response, api) {
    let res = response.data;
    // TODO
    const rules = {
      '200': (res) => {
        return res;
      },
      '103': () => {
        $cache.localClear($cache.AUTH);
        logoutBySSO();
      },
      '102': (data) => {
        Message.error(data.message);
        // 须抛出异常，中断正常流程。
        // eslint-disable-next-line no-throw-literal
        throw {
          message: `${data.message || '未知原因'}`,
          stack: new Error().stack,
          code: data.code,
        };
      },
    };
    if (rules[res.code]) {
      return rules[res.code](res);
    }
    // not define code throw error
    DataCenterLog.send({
      item: 2001,
      path: api.url,
      author: api.author,
      code: res.code,
      message: res.message,
    });
    /* eslint-disable no-throw-literal */
    throw {
      // message: `请求失败code: ${res.code}, message: ${res.message || '未知原因'}，接口开发者：${api.author}`,
      message: `${res.message || '未知原因'}`,
      stack: new Error().stack,
      code: res.code,
    };
    /* eslint-enable no-throw-literal */
  }
  errorInterceptor(error) {
    let status = 0;
    if (error.response) {
      status = error.response.status;
    } else if (error.request) {
      status = error.request.status;
    }
    throw new Error(`网络错误 [ ${status} ] ${error.message} `);
  }
  getProject() {
    return this.apiDomain.getProject();
  }

  getBranch() {
    return this.apiDomain.getBranchMap();
  }

  isProduct() {
    return this.apiDomain.isProduct();
  }

  getProjectTitle() {
    return this.apiDomain.getProjectTitle();
  }
}

export default QuRequest;
